<template>
  <div>
    <v-app v-if="!sameVersion && token">
      <RefreshApp />
    </v-app>
    <v-app v-else>
      <AppBar
        v-if="showLayout"
        :is-open="isSidebarOpen"
        @toggle="toggleSidebar"/>
      <SideBar
        v-if="showLayout"
        :is-open="isSidebarOpen"
        @toggle="toggleSidebar"/>

      <OnboardingProviderModal
        ref="onboarding-provider"
        v-if="showLayout"
      />

      <UpdateUserInfo
        ref="updateUserInfo"
        v-if="hasInfo"
        :data="data"
      />

      <v-main app>
        <v-layout class="grey lighten-4" column fill-height>
          <v-alert
              class="ma-5"
              v-show="showLayout && alert"
              :v-model="alert"
              dismissible
              color="red"
              border="left"
              elevation="2"
              colored-border
              icon="mdi-alert-octagon"
              transition="scale-transition"
            >
              {{ messageError }}
            </v-alert>
            <v-alert
              class="ma-5"
              v-show="showLayout && !isLive && !provider"
              border="left"
              elevation="2"
              colored-border
              icon="mdi-alert-octagon"
              transition="scale-transition"
              type="warning"
            >
              Para poder hacer uso de todas las características de Eato es necesario subir los datos fiscales. <router-link class="primary--text" to="/settings/restaurant">Ir a configurar mis datos fiscales</router-link>
            </v-alert>
          <v-container grid-list-xl fluid fill-height>
            <router-view :key="key"></router-view>
          </v-container>
          <v-footer padless>
            <v-row>
              <v-col>
                <v-row class="justify-center">
                  FOOD CHAIN SOLUTIONS MX 2023 - v.{{version}}
                </v-row>
                <v-row class="justify-center mb-4">
                  <a class="primary--text" @click="isOpen = true" ><strong>Aviso de privacidad</strong></a>
                </v-row>
              </v-col>
            </v-row>
          </v-footer>
        </v-layout>
      </v-main>
    </v-app>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import UpdateUserInfo from '@/components/modals/onboarding/UpdateUserInfo'

export default {
  name: 'App',
  components: {
    SideBar: () => import(/* webpackChunkName: "app-ui" */ '@/components/SideBar'),
    AppBar: () => import(/* webpackChunkName: "app-ui" */ '@/components/AppBar'),
    OnboardingProviderModal: () => import(/* webpackChunkName: "app-ui" */ '@/components/modals/OnboardingProvider'),
    UpdateUserInfo,
    RefreshApp: () => import(/* webpackChunkName: "app-ui" */ '@/screens/sessions/RefreshApp')
  },
  data () {
    return {
      isSidebarOpen: false,
      alert: false,
      messageError: '',
      isOpen: false,
      data: {
        firstName: null,
        lastName: null,
        phone: null
      }
    }
  },
  computed: {
    ...mapGetters({
      isLive: 'currentRestaurant/isLive'
    }),
    permissions () {
      return this.$store.state.login.permissions
    },
    restaurant () {
      return this.$store.state.currentRestaurant.data._id
    },
    provider () {
      return this.$store.state.currentProvider.data._id
    },
    key () {
      if (this.$store.state.restaurant && this.$store.state.area) {
        return this.$store.state.restaurant.uuid + this.$store.state.area.id
      }
      return 1
    },
    hasInfo () {
      return !!(this.$store.state.login.token)
    },
    showLayout () {
      if (this.$store.state.userProvider) {
        return !!(this.$store.state.login.token && this.provider && this.permissions)
      }

      return !!(this.$store.state.login.token && this.restaurant && this.permissions)
    },
    token () {
      return this.$store.state.login.token
    },
    version () {
      return process.env.VUE_APP_VERSION
    },
    sameVersion () {
      return this.$store.state.version === this.version
    },
    isInvitation () {
      return this.$route.name === 'AcceptInvitation'
    }
  },
  watch: {
    restaurant: async function (val) {
      if (val) {
        await this.$store.dispatch('currentRestaurant/subscribeRestaurantChannel')
        await this.$store.dispatch('login/subscribeUnitsChannel')
      }
    },
    isInvitation (val) {
      if (val) {
        this.$store.dispatch('logout')
      }
    },
    showOnboardingModal (val) {
      if (!val) {
        this.$refs['onboarding-provider'].close()
      }
    },
    showLayout (val) {
      if (val) {
        this.hasAttributes()
        this.getMessagesErrors()
      }
    }
  },
  mounted: async function () {
    if (this.showLayout) {
      this.hasAttributes()
      this.getMessagesErrors()
    }
    if (this.isInvitation) {
      this.$store.dispatch('logout')
    }
    if (this.restaurant) {
      await this.$store.dispatch('currentRestaurant/subscribeRestaurantChannel')
      await this.$store.dispatch('login/subscribeUnitsChannel')
    }
    this.hasAttributes()
  },
  methods: {
    async getMessagesErrors () {
      const params = {
        key: 'error_restaurant'
      }
      if (this.$store.state.userProvider) params.key = 'error_provider'
      try {
        const response = await this.$api.get(`/v1/app-config`, params)
        if (response) {
          this.alert = true
          this.messageError = response.description
        } else {
          this.alert = false
        }
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
    },
    toggleSidebar (isOpen) {
      this.isSidebarOpen = isOpen
    },
    hasAttributes () {
      const showModal = !!(!this.$store.state.login.user.firstName || !this.$store.state.login.user.lastName || !this.$store.state.login.user.phone)
      if (showModal) {
        this.data = {
          firstName: this.$store.state.login.user.firstName || '',
          lastName: this.$store.state.login.user.lastName || '',
          phone: this.$store.state.login.user.phone || ''
        }
        this.$refs.updateUserInfo.open()
      }
    }
  }
}
</script>

<style lang="scss">
.v-alert {
  font-size: 12px;
}

.v-card__title {
  word-break: break-word;
}

.v-label {
  font-size: 12px !important;
}

.v-input {
  font-size: 12px !important;

  &__slot, .v-input__control {
    min-height: 30px !important;
  }
}

.v-text-field {
  .v-input__prepend-inner {
    margin-top: 5px !important;

    .theme--light.v-icon {
      color: black;
    }
  }
}

.v-select__selections, .v-text-field__slot {
  padding: 0px !important;
}

.v-btn:not(.v-btn--round).v-size--small {
  height: 32px !important;
}

.v-text-field--outlined.v-input--dense .v-label {
  top: 5px !important;
}

.v-tooltip__content { pointer-events: initial !important; }

.v-data-table__mobile-row__cell {
  text-align: left !important;
}

.toasted .primary, .toasted.toasted-primary {
  font-weight: normal;
}

.align-right {
  float: right;
}

</style>
